import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/base-components';
import { I18nModule } from 'haba-core';
import { OrderStatusComponent } from './order-status.component';

import { UserModule } from '../../user/user.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormFieldsModule,
    RouterModule.forChild([
      {
        path: 'bestellstatus',
        component: OrderStatusComponent,
      },
    ]),
    UserModule,
    OrderStatusComponent,
  ],
  exports: [OrderStatusComponent],
})
export class OrderStatusModule {}
